import { types } from '../types/types'

const initialState = {
    stocks: [],
}

export const stockReducer = (state = initialState, action) => {

    switch (action.type) {

        case types.stockLoaded:
            return {
                stocks: [...action.payload]
            }

        default:
            return state;
    }
}

export default stockReducer;